export default "__VITE_ASSET__fc15e14d__"